var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48594 4.48594 0 10 0C15.5141 0 20 4.48594 20 10C20 15.5141 15.5141 20 10 20C4.48594 20 0 15.5141 0 10ZM1.6216 10C1.6216 14.62 5.38027 18.3784 10 18.3784C14.62 18.3784 18.3784 14.62 18.3784 10C18.3784 5.38023 14.62 1.6216 10 1.6216C5.38023 1.6216 1.6216 5.38027 1.6216 10ZM13.8476 6.68215C14.1727 6.37352 14.6859 6.38781 14.9938 6.71242C15.3021 7.03731 15.2884 7.55055 14.9636 7.85867L9.2068 13.3181C9.04977 13.4665 8.84922 13.5405 8.64867 13.5405C8.43731 13.5405 8.22649 13.4584 8.06785 13.2954L5.04082 10.1876C4.7284 9.86676 4.73516 9.35352 5.05598 9.0411C5.37707 8.72836 5.88977 8.73539 6.20246 9.05621L8.67137 11.5911L13.8476 6.68215Z",
    fill: "#00C8A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.af24a7a3.svg";
export { ForwardRef as ReactComponent };